import React, { Component } from 'react';
import { IntlProvider, intlShape, injectIntl } from 'react-intl';
import { flattenMessages } from '@utils/languageUtils';
import { getUserLang } from '@utils/localeUtils';
import ptBR from './i18n/ptBR';
import enUS from './i18n/enUS';
import esES from './i18n/esES';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ButtonFAB from '@components/ButtonFAB/ButtonFAB';
import CardFilters from '@components/CardFilters/CardFilters';
import GroupButtonGrid from '@components/GroupButtonGrid/GroupButtonGrid';
import DataTable from '@components/DataTable/DataTable';
import { withStyles } from '@material-ui/core';
import swal from '@sweetalert/with-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import iconAdd from '@images/icone_add.png';
import FilterUtil from '../../filterUtil';
import Loading from '@components/Loading/Loading';
import green from '@material-ui/core/colors/green';
import Regioes from '@resources/Regiao';

let messages = { 'pt-BR': ptBR, 'en-US': enUS, 'es-ES': esES };

var { provider } = new IntlProvider({});

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflowY: 'scroll'
  },
  cardGrid: {
    marginTop: 30,
    marginBottom: 15,
    display: 'contents',
    width: '100%',
    flex: 1
  }
};

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: green,
    type: 'light'
  }
});

/**
 * Tela de listagem de Região
 *
 * @author Gabriela Farias
 * @class Regiao
 * @extends {Component} - Componente React
 */
class Regiao extends Component {
  constructor(props) {
    super(props);

    const messagesLinguage = flattenMessages(messages[getUserLang()]);
    const regiao = messagesLinguage['regiao.regiao'];
    const regioes = messagesLinguage['regiao.regioes'];
    const desejaExcluir = messagesLinguage['regiao.desejaExcluir'];
    const nao = messagesLinguage['regiao.nao'];
    const excluir = messagesLinguage['regiao.excluir'];
    const excluindo = messagesLinguage['regiao.excluindo'];
    const regiaoRemovidoComSucesso = messagesLinguage['regiao.regiaoRemovidoComSucesso'];
    const falhaAoExcluirRegiao = messagesLinguage['regiao.falhaAoExcluirRegiao'];

    const intlProvider = new IntlProvider({
      locale: getUserLang(),
      messages: {
        regiao,
        regioes,
        desejaExcluir,
        excluir,
        nao,
        excluindo,
        regiaoRemovidoComSucesso,
        falhaAoExcluirRegiao
      }
    });

    provider = intlProvider.getChildContext();

    this.state = {
      operationTypeString: [
        {
          label: provider.intl.formatMessage({ id: 'regiao' }),
          field: 'nmRegiao',
          type: 'string'
        }
      ],
      dataAppSync: [],
      dataInTable: [],
      head: [
        {
          field: 'nmRegiao',
          headerName: provider.intl.formatMessage({ id: 'regiao' }),
          col: 12
        }
      ],
      itemSelect: '',
      disabledEdit: true,
      loading: true
    };

    const title = 'regiao.regioes';
    if (this.props.itensState.name !== 'regiao.regioes') {
      this.props.dispatch({
        type: 'UPDATE_TOOLBAR',
        toolbar: (
          <IntlProvider locale={getUserLang()} messages={flattenMessages(messages[getUserLang()])}>
            <FormattedMessage id={title} />
          </IntlProvider>
        ),
        name: title
      });
    }

    this.onFilter = this.onFilter.bind(this);
    this.clickEditar = this.clickEditar.bind(this);
    this.clickAdicionar = this.clickAdicionar.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
    this.clickExcluir = this.clickExcluir.bind(this);
    this.atualizarRegistros = this.atualizarRegistros.bind(this);
  }

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount() {
    this.onFilter(this.props.chipData);
  }

  onFilter(dataChips) {
    Regioes.findAllRegiao()
      .then(query => {
        var data = query.data.map(doc => {
          return doc;
        });
        this.setState({
          dataInTable: FilterUtil.applyFilters(data, dataChips),
          loading: false,
          dataAppSync: data
        });
      })
      .catch(() => {
        this.setState({
          dataInTable: [],
          dataAppSync: [],
          loading: false
        });
      });
  }

  clickEditar() {
    this.props.history.push('/app/regiao/editar/' + this.state.itemSelect.idRegiao);
  }

  clickAdicionar() {
    this.props.history.push('/app/regiao/novo');
  }

  selectChange(select) {
    if (select) {
      this.setState({
        itemSelect: select,
        disabledEdit: false
      });
    } else {
      this.setState({
        itemSelect: '',
        disabledEdit: true
      });
    }
  }

  onFilterChanged(dataChips) {
    this.setState({
      dataInTable: FilterUtil.applyFilters(this.state.dataAppSync, dataChips)
    });
  }

  clickExcluir() {
    swal({
      title: provider.intl.formatMessage({ id: 'desejaExcluir' }),
      icon: 'warning',
      closeOnClickOutside: false,
      closeOnEsc: false,
      buttons: {
        cancel: {
          text: provider.intl.formatMessage({ id: 'nao' }),
          value: false,
          visible: true,
          closeModal: true,
          className: 'swal2-cancel'
        },
        confirm: {
          text: provider.intl.formatMessage({ id: 'excluir' }),
          value: true,
          visible: true,
          closeModal: false,
          className: 'swal2-confirm'
        }
      }
    }).then(willDelete => {
      if (willDelete) {
        swal.stopLoading();
        swal(
          <div>
            <MuiThemeProvider theme={theme}>
              <CircularProgress />
            </MuiThemeProvider>
          </div>,
          {
            buttons: false,
            closeOnClickOutside: false,
            title: provider.intl.formatMessage({ id: 'excluindo' })
          }
        );
        Regioes.deleteRegiaoById(this.state.itemSelect.idRegiao)
          .then(() => {
            swal(
              provider.intl.formatMessage({
                id: 'regiaoRemovidoComSucesso'
              }),
              {
                icon: 'success',
                buttons: {
                  confirm: {
                    text: 'Ok',
                    value: true,
                    visible: true,
                    closeModal: true,
                    className: 'swal2-Ok'
                  }
                }
              }
            ).then(() => {
              this.atualizarRegistros(this.state.itemSelect.idRegiao);
            });
          })
          .catch(error => {
            swal(provider.intl.formatMessage({ id: 'falhaAoExcluirRegiao' }), {
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Ok',
                  value: true,
                  visible: true,
                  closeModal: true,
                  className: 'swal2-error'
                }
              }
            });
          });
      }
    });
  }

  atualizarRegistros(dataRegiao) {
    var ajusteRegistros = this.state.dataAppSync.filter(data => {
      return dataRegiao !== data.idRegiao;
    });

    this.setState({
      dataAppSync: ajusteRegistros,
      dataInTable: ajusteRegistros
    });

    this.onFilterChanged(this.props.chipData);
  }

  render() {
    const pagination = {
      length: this.state.dataInTable.length,
      page: 0
    };

    const { classes } = this.props;

    return (
      <IntlProvider locale={getUserLang()} messages={flattenMessages(messages[getUserLang()])}>
        <div className={classes.card}>
          {this.state.loading && <Loading />}
          <CardFilters
            filtros={this.state.operationTypeString}
            usePaddings={false}
            onFilter={this.onFilter}
            onFilterChanged={this.onFilterChanged}
            viewKey='regiao'
          />
          <GroupButtonGrid
            showAdd={false}
            showEdit={true}
            showDelete={true}
            disableEdit={this.state.disabledEdit}
            disableDelete={this.state.disabledEdit}
            onClickDelete={this.clickExcluir}
            onClickEdit={this.clickEditar}
          />

          <div className={classes.cardGrid}>
            <DataTable
              data={this.state.dataInTable}
              columns={this.state.head}
              selectChange={this.selectChange}
              showPagination={true}
              pagination={pagination}
            />
          </div>

          <ButtonFAB icon={iconAdd} positionDefault={true} onClick={this.clickAdicionar} />
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'regiao';
  })[0].content
});

Regiao.propTypes = {
  intl: intlShape.isRequired
};

let enhaced = injectIntl(withStyles(styles)(Regiao));
export default withRouter(connect(mapStateToProps)(enhaced));
